import { MutationTree } from 'vuex';
import { PreprocessingRulesState } from './types';

export const mutations: MutationTree<PreprocessingRulesState> = {
  setPreprocessingRules: (state, data) => {
    state.preprocessingRules = data;
  },
  setPreprocessingRuleItem: (state, data) => {
    state.preprocessingRuleItem = data;
  }
};